import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import { MessageCircle } from "lucide-react";

const WHATSAPP_INVITE_URL = "https://chat.whatsapp.com/GFsyEskI2o7CWiPWq3qQRx?mode=gi_t";

export default function WhosGoing() {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get("/rsvps/public").then((r) => setGuests(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const names = guests.flatMap((g) => {
    const list = [g.guest_name];
    if (g.partner_name && g.partner_name.trim()) list.push(g.partner_name);
    return list;
  });

  return (
    <div className="bg-cream">
      <section className="pt-20 pb-10 md:pt-28 md:pb-14" data-testid="whos-going-hero">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-terracotta font-medium mb-4">The Guestlist</p>
          <h1 className="font-display text-6xl md:text-8xl font-black text-ink leading-[0.9]">
            Who's <span className="italic text-sage-dark">going.</span>
          </h1>
          <p className="text-lg text-muted_ink mt-5 max-w-2xl">
            Names pop up as people RSVP yes. If you're not here yet, {" "}
            <a href="/rsvp" className="sun-underline font-medium text-ink">fix that</a>.
          </p>

          <a
            href={WHATSAPP_INVITE_URL}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-sage text-white px-6 py-3 font-bold tracking-wide hover:bg-sage-dark hover:-translate-y-0.5 transition-all duration-300 shadow-[0_4px_0_0_#16A34A]"
            data-testid="whatsapp-join-btn"
          >
            <MessageCircle className="w-5 h-5" />
            Join the WhatsApp group
          </a>
          <p className="text-xs text-muted_ink mt-3 tracking-wide">
            For logistics chatter, meetup plans, and who's flying in when.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          {loading ? (
            <p className="text-center text-muted_ink">Loading…</p>
          ) : names.length === 0 ? (
            <div className="text-center py-24 border border-dashed border-shell rounded-lg" data-testid="guests-empty">
              <p className="font-display text-3xl font-black text-ink">No one yet.</p>
              <p className="text-muted_ink mt-3">Be the first — it's a look.</p>
            </div>
          ) : (
            <>
              <div className="mb-8 flex items-center gap-4">
                <p className="font-display text-5xl font-black text-terracotta tabular-nums" data-testid="guest-count">{names.length}</p>
                <p className="text-muted_ink text-sm tracking-widest uppercase leading-tight">
                  confirmed<br />
                  and counting
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-6 gap-y-3" data-testid="guest-list">
                {names.map((n, i) => (
                  <div key={i} className="font-display text-ink text-lg md:text-xl font-medium border-b border-dashed border-shell pb-2" data-testid={`guest-${i}`}>
                    {n}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
